export function experienceFormatter (value) {
  value = parseInt(value)
  switch (value) {
    case 0:
      return 'Weniger als ein Jahr'
    case 11:
      return 'Mehr als 10 Jahre'
    default:
      return value.toString()
  }
}

export function salaryFormatter (value) {
  return isNaN(value) ? value : (new Intl
    .NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0 })
    .format(value) + ' brutto')
}

export function dateFormatter (value) {
  value = value.split('-').map(Number)

  return (new Date(value[0], value[1] - 1, value[2])).toLocaleDateString('de-DE');
}

export const lang = {
  drivers_license: 'Führerschein',
  entry_95: 'Fahrerkarte und Eintrag',
  work_experience_in_years: 'Berufserfahrung in Jahren',
  linquistic_proficiency: 'Sprachkenntnisse',
  interest_in_it: 'Interesse an IT',
  possible_start_of_work: 'Frühestmöglicher Eintrittstermin',
  salary_expectations: 'Gehaltsvorstellung',
  personal_data: 'Persönliche Daten',
  additional_information: 'Zusätzliche Angaben',
  first_name: 'Vorname',
  last_name: 'Nachname',
  telephone: 'Telefon',
  email: 'E-Mail-Adresse',
  address: 'Adresse',
  street: 'Straße',
  city: 'Stadt',
  postal_code: 'Postleitzahl',
  house_number: 'Hausnummer',
  qualifications: 'Qualifizierungen',
  select_all_that_apply: 'Bitte alle zutreffenden auswählen.',
}
